import Manager from '../../../core/Manager';
import showdown from 'showdown';

export default class LocalizedString {
  public en;

  public fr;

  constructor(row: any, iconLinks: boolean = false) {
    let en = row.en;
    let fr = row.fr ?? en;

    if (!row.html) {
      en = LocalizedString.markdownToHtml(en, iconLinks);
      fr = LocalizedString.markdownToHtml(fr, iconLinks);
    }

    this.en = en;
    this.fr = fr;
  }

  get() {
    const locale = Manager.getInstance().i18n.global.locale;
    return this[locale];
  }

  private static markdownToHtml(markdown: string, iconLinks: boolean): string {
    const converter = new showdown.Converter();
    converter.setOption('simpleLineBreaks', true);
    converter.setOption('openLinksInNewWindow', true);

    const div = document.createElement('div');
    div.innerHTML = converter.makeHtml(markdown);

    if (iconLinks) {
      LocalizedString.iconLinks(div);
    }

    return div.firstElementChild?.innerHTML;
  }

  private static iconLinks(div: HTMLElement) {
    const links = div.querySelectorAll('a');
    links.forEach((a) => {
      const labelText = a.innerText;
      const icon = document.createElement('div');
      icon.setAttribute('class', 'icon');
      const label = document.createElement('div');
      label.setAttribute('class', 'label');
      label.innerText = labelText;
      a.innerHTML = '';
      a.appendChild(icon);
      a.appendChild(label);
    });
  }
}
